import { render, staticRenderFns } from "./performancemanagement.vue?vue&type=template&id=9825e40c&scoped=true&"
import script from "./performancemanagement.vue?vue&type=script&lang=js&"
export * from "./performancemanagement.vue?vue&type=script&lang=js&"
import style0 from "./performancemanagement.vue?vue&type=style&index=0&id=9825e40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9825e40c",
  null
  
)

export default component.exports